import CryptoJS from "crypto-js";

const encryptData = (message) => {
  // Encrypt
  var ciphertext = CryptoJS.AES.encrypt(
    message,
    import.meta.env.VITE_SECRET_KEY
  ).toString();
  return ciphertext;
};

const decryptSingleData = (message) => {
  // Decrypt
  let bytes = CryptoJS.AES.decrypt(message, import.meta.env.VITE_SECRET_KEY);
  let originalText = bytes.toString(CryptoJS.enc.Utf8);
  return JSON.parse(originalText);
};

export { decryptSingleData, encryptData };
